/* eslint-disable no-undef */
// eslint-disable-next-line react/no-deprecated
import { hydrate } from 'react-dom';
import { Globals } from '@bwoty-web/ui-kit';
import HeaderGlobetrotter from '../shared/header/HeaderGlobetrotter';

const initialStateHeader = window.__INITIAL_STATE_HEADER__;
// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = `${initialStateHeader?.baseUrl}/static/`;

// comment out delete, state is shared with globeSearch
// delete window.__INITIAL_STATE_HEADER__;

const headerRoot = document.getElementById('header');

if (headerRoot) {
  hydrate(
    <Globals {...initialStateHeader}>
      <HeaderGlobetrotter {...initialStateHeader}/>
    </Globals>,
    headerRoot,
  );
}
